import React, { ChangeEvent } from 'react';

import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { type FieldProps } from 'formik';
import { Translate } from 'react-localize-redux';

import { formikValidate } from '../../../../../helpers/validation';
import FormItem from '../FormItem';

const advanceValidation = (value: number) => {
  const max = 360;
  const min = 1;

  return (
    formikValidate.required(value) ||
    formikValidate.digits(value) ||
    formikValidate.max(max)(value) ||
    formikValidate.min(min)(value)
  );
};

type Props = {
  canEdit: boolean;
};

const MaxOrderAheadDays = ({ canEdit }: Props) => {
  return (
    <FormItem
      divider
      primary={<Translate id="Preorder_settings_advance_item_title" />}
      name="MaxOrderAheadDays"
      validate={advanceValidation}
    >
      {({ field, form }: FieldProps) => {
        const { errors, touched } = form;
        const fieldError = errors[field.name] as string | undefined;
        const showError = !!fieldError && (touched[field.name] as boolean | undefined);

        return (
          <TextField
            variant="standard"
            fullWidth
            disabled={!canEdit}
            value={field.value}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              form.setFieldValue(field.name, e.target.value);
            }}
            error={showError}
            helperText={showError ? fieldError : undefined}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                  <Translate id="Days" />
                </InputAdornment>
              ),
            }}
            inputProps={{
              maxLength: 3,
              'data-fd': 'pre_order_settings_max_order_ahead_days',
            }}
          />
        );
      }}
    </FormItem>
  );
};

export default MaxOrderAheadDays;
